import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function ArrowSmallRightIcon({
	width = 11,
	height = 9,
	color = 'currentColor',
	style,
	...rest
}: IconRenderProps): ReactElement {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 11 9"
			fill="none"
			aria-hidden="true"
			focusable="false"
			style={{ display: 'block', flexShrink: 0, ...style }}
			{...rest}
		>
			<path
				d="M11 4.5L6.50098 9L5.50977 8.00879L8.31641 5.20117H0V3.79883H8.31641L5.50977 0.991211L6.50098 0L11 4.5Z"
				fill={color}
			/>
		</svg>
	);
}
